import assetPath from '/app/packages/lebenslauf/articles/src/assets/erfolgreiche-bewerbungsmappe-so-ueb-1.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')